export enum SizeUnit {
  'Auto' = 0,
  'B'= 1,
  'kB'= 1e3,
  'MB'= 1e6,
  'GB'= 1e9
}
